import type { ImgHTMLAttributes } from "react";

/** Asset path for the active SecOps mark (v2 shield+lock). Versioned as icon-v2.svg in public/icons. */
export const BRAND_MARK_SRC = "/icons/icon.svg";

type BrandMarkProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt">;

/**
 * SecOps brand mark — loads the shared SVG asset so gradients/orbits stay intact.
 * Consoles used to inline the v1 shield-check paths; v2 lives in public/icons/.
 */
export function BrandMark({ className, ...props }: BrandMarkProps) {
  return (
    <img
      src={BRAND_MARK_SRC}
      alt=""
      className={className}
      aria-hidden="true"
      draggable={false}
      {...props}
    />
  );
}
